import { useEffect } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'

import { Content, ContentHeader } from 'components/v2/Content'
import Heading from 'components/v2/Heading'
import Card from '@10xLabs/react-web/components/Card'
import { ForbiddenView } from 'features/App/components/ForbiddenView'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { canShowInsuranceSettings } from 'features/Users/utils'
import { InsuranceSettingsCard } from './InsuranceSettingsCard'
import { withCompany } from './WithCompany'
import { useLogin } from 'features/Login/hooks'

const messages = defineMessages({
  helmet: {
    id: 'ancillaries.settings.helmet',
    defaultMessage: 'Ancillaries settings | Nexbus Admin'
  }
})

const CardsList = (props: TSFixMe): TSFixMe => {
  const login = useLogin()

  return (
    <section>
      {canShowInsuranceSettings(login.accessToken.policies) ? (
        <Card.Container>
          <InsuranceSettingsCard {...props} />
        </Card.Container>
      ) : (
        <ForbiddenView feature={FEATURES.COMPANY} />
      )}
    </section>
  )
}
const CardsWithCompany = withCompany(CardsList)

const NewSiteView = (): TSFixMe => {
  const intl = useIntl()

  useEffect((): TSFixMe => {
    document.title = intl.formatMessage(messages.helmet)
  }, [])

  return (
    // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
    <Content hasSidebar hasHeader hasMaxWidth>
      <ContentHeader>
        <Heading.H3>
          <FormattedMessage id="ancillaries.settings.edit.title" defaultMessage="Ancillaries" />
        </Heading.H3>
      </ContentHeader>

      <CardsWithCompany />
    </Content>
  )
}

export default NewSiteView
